// extracted by mini-css-extract-plugin
export default {"container":"qn-z","freeShip":"rn-z","privacy":"sn-z"};